module.exports = __webpack_public_path__ + "static/logo-019fe5be437b5c724fa55061cfe27e4c.png";